var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-info"},[_c('img',{staticClass:"empty-img",attrs:{"src":_vm.empty,"alt":""}}),_c('div',[_vm._v("输入网址错误，找不到机构，请联系老师")])])}
var staticRenderFns = []

export { render, staticRenderFns }